/*

class to generate clinical impression finding

http://www.hl7.org/fhir/clinicalimpression-definitions.html#ClinicalImpression.finding

{
  "itemcode" : { code }, // What was found
  "itemReference" : { Reference(Condition|Observation|Media) }, // What was found
  "basis" : "<string>" // Which investigations support finding
}

*/

// Import libraries
const Joi = require('joi');

// Import variables
const { joiValidateObj } = require('../datastructComponents');
const { codeSchema } = require('./code.class');
// const { conditionSchema } = require('./condition.class');

// Create schema
const schema = {
  itemcode: Joi.object().keys( codeSchema ).optional(),
  // itemReference: Joi.object().keys( conditionSchema ).optional(), // TODO consider moving condition elsewhere? Rearrange structure
  basis: Joi.string().optional(),
};

// Define class
class Finding {
  constructor ( obj ) {
    joiValidateObj(schema, obj);
    for (const key of Object.keys(obj)) {
      if(obj[key] || obj[key] === false) {
        this[key] = obj[key];
      }
    }
  }
}

exports.Finding = Finding;
exports.findingSchema = schema;